<script lang="ts">
  import { Stack, StackItem } from '@athena-lib/Stack';
  import { BaseHeading, type HeadingSize } from '@athena-lib/Text';
  import clsx from 'clsx';
  import type { Link, Richtext } from '@storyblok-types';
  import { ButtonLink, type ButtonColor } from '@athena-lib/Button';
  import { parseHeadingLevel } from '@athena-lib/Text/BaseHeading/types';
  import { RichText } from '../../RichText';
  import { isRichTextEmpty } from '../../RichText/types';
  import AddToCartButton from '../AddToCartButton.svelte';
  import { type Alignment, alignClasses } from './page-section-utils';
  import { getUrlByLinkType } from '$lib/utilities/storyblok';

  const {
    headingText,
    headingTag,
    headingSize,
    allowFullWidthHeading,
    mobileAlignment,
    desktopAlignment,
    description,
    ctaButton,
  }: {
    headingText?: string;
    headingTag?: string;
    allowFullWidthHeading?: boolean;
    headingSize?: string | number;
    mobileAlignment: string | number | undefined;
    desktopAlignment: string | number | undefined;
    description?: Richtext;
    ctaButton?: {
      text: string | undefined;
      color: string | number | undefined;
      link: Link | undefined;
      addToCart?: boolean;
      productId?: string;
      productType?: 'sticker-pack' | 'giftcard' | 'sticker-sample' | undefined;
      productImageUrl?: string;
      class?: string;
    };
  } = $props();
</script>

<Stack
  space={(headingSize as HeadingSize) === 'small' ? 'small' : 'gutter'}
  class={clsx(
    alignClasses['mobile'][(mobileAlignment ?? 'left') as Alignment],
    alignClasses['desktop'][(desktopAlignment ?? 'left') as Alignment],
  )}
>
  {#if headingText}
    <StackItem>
      <BaseHeading
        class={clsx(allowFullWidthHeading !== true && 'max-w-text-max')}
        level={parseHeadingLevel(headingTag) ?? 2}
        size={headingSize as HeadingSize}
      >
        {headingText}
      </BaseHeading>
    </StackItem>
  {/if}
  {#if !isRichTextEmpty(description)}
    <StackItem class="max-w-text-max">
      <RichText text={description} />
    </StackItem>
  {/if}
  {#if ctaButton?.text && !ctaButton.addToCart}
    <StackItem>
      <ButtonLink
        link={getUrlByLinkType(ctaButton.link)}
        color={(ctaButton.color as ButtonColor) ?? 'dark'}
        class={ctaButton.class}
      >
        {ctaButton.text}
      </ButtonLink>
    </StackItem>
  {:else if ctaButton?.text && ctaButton.addToCart}
    <StackItem>
      <AddToCartButton
        color={(ctaButton.color as ButtonColor) ?? 'dark'}
        productId={ctaButton.productId}
        productImageUrl={ctaButton.productImageUrl}
        buttonText={ctaButton.text}
        productType={ctaButton.productType}>{ctaButton.text}</AddToCartButton
      >
    </StackItem>
  {/if}
</Stack>
